import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CompanyOffersService } from '../../../features/Company-Admin/company-offers/services/company-offers.service';
import { ListData, ListFilter } from '../../../features/Company-Admin/company-offers/models/company-offers';


export interface DialogData {
  vendorId: any
}

@Component({
  selector: 'app-vendor-offers',
  templateUrl: './vendor-offers.component.html',
  styles: ``
})
export class VendorOffersComponent {
  showFilter = false;
  dataLoading = false;

  pageIndex = 0;
  pageSize = 4;
  pageCount = 0;
  recordsData!: ListData | null;
  offersList: any = []
  count_not_ended!: number
  count_ended!: number

  filterModel: ListFilter = new ListFilter();
  constructor(private dialogRef: MatDialogRef<VendorOffersComponent>,
    private translate: TranslateService,
    private service: CompanyOffersService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }


  ngOnInit(): void {
    this.getVendorOffers()
  }

  getVendorOffers() {
    this.dataLoading = true;
    this.filterModel.page = this.pageIndex + 1;
    this.filterModel.perPage = this.pageSize;
    this.filterModel.sort = 'DESC';
    this.filterModel.sortBy = 'created_at';
    this.filterModel.vendor_id = this.data?.vendorId;
    this.service.getAllOffers(this.filterModel).subscribe((res: any) => {
      this.offersList = res.data.list;
      this.dataLoading = false;
    })
  }
}
